<div class="inner-content">
  <main class="modal-ins-wrapper">
    <div class="ion-text-right">
      <ion-button fill="clear" class="close-modal-button" slot="icon-only" (click)="closeModal()" id="closeButton">
        <ion-icon name="wg-outline-multiply"></ion-icon>
      </ion-button>
    </div>
    <ion-text class="ion-text-center">
      <h2 class="wg-h-md" *ngIf="option === 'login'">{{ 'ThroughOptionPage.loginText' | translate }}</h2>
      <h2 class="wg-h-md" *ngIf="option === 'register'">{{ 'ThroughOptionPage.signupText' | translate }}</h2>
    </ion-text>
    <p>{{ 'ThroughOptionPage.signupInstruction' | translate }}</p>
    <ion-button class="wg-btn-large" id="login-button-mobile" color="secondary" expand="block" (click)="routeTo('mobile')">
      <ion-icon name="wg-phone"></ion-icon>
      {{ 'ThroughOptionPage.mobile' | translate }}
    </ion-button>
    <ion-button class="wg-btn-large" id="login-button" color="primary" expand="block" (click)="routeTo('email')">
      <ion-icon name="wg-email"></ion-icon>
      {{ 'ThroughOptionPage.email' | translate }}
    </ion-button>
  </main>
</div>
